<template>
    <footer>
      <div class="bg-patter py-3 py-lg-5">
        <div class="container">
          <div class="row">
            <div class="col-4 col-lg-6 text-blue">
                <ul class="footer-links footer-text">
                    <li><a :href="getUrl('voucherBookUrl')" v-text="getTranslation('voucherBookLinkLabel')"></a></li>
                    <li><a :href="getUrl('promotionsUrl')" v-text="getTranslation('promotionsLabel')"></a></li>
                    <li><a :href="getUrl('seasonpassesUrl')" v-text="getTranslation('seasonpassesLinkLabel')"></a></li>
                    <li><a href="#">Recargas</a></li>
                    <li><a href="#">Precios en boletería</a></li>
                </ul>
            </div>
            <div class="col-8 col-lg-6">
                <p class="text-blue footer-text mb-0">
                    Empresa: Valle nevado<br>
                    Representante Legal: Ricardo Margulis Budnik<br>
                    Dirección: Isidora Goyenechea 2800 Of. 502, Las Condes, Santiago, Chile<br>
                    Teléfono de contacto: (56-2) 2477 77 01<br>
                    Tickets:valleplusonline@vallenevado.com<br>
                    Pases invierno y verano: pasesdetemporada@vallenevado.com<br>
                    Términos y condiciones
                </p>
            </div>
          </div>
        </div>
      </div>
      <div class="py-3 bg-blue py-lg-4">
        <div class="container">
          <div class="row text-white">
            <div class="col-lg d-none d-lg-block align-self-center">
              <a class="navbar-brand" href="#"><img class="nav-logo" src="~__STATIC__/svg/valle.svg" alt="logo"></a>
              <a class="navbar-brand" href="#"><img class="nav-logo" src="~__STATIC__/svg/valle-plus.svg" alt="logo"></a>
            </div>
            <div class="col-lg d-none d-lg-block align-self-center">
                <p class="footer-text mb-0">Se el primero en enterarte de todas nuestras novedades y promociones</p>
              </div>
              <div class="col-8 col-lg align-self-md-center">
<!--                  <h3 class="ff-gotham font-weight-bold ls-3 mb-lg-1">¡INSCRIBETE!</h3>
                  <p class="footer-text d-lg-none">Se el primero en enterarte de todas nuestras novedades y promociones</p>
                  <form class="row form-email">
                      <div class="col pr-0">
                          <input type="email" class="form-control rounded-0" id="email" placeholder="Correo electrónico">
                      </div>
                      <div class="col pl-1">
                          <button type="submit" class="btn btn-light rounded-0">Enviar</button>
                      </div>
                  </form>-->
              </div>
              <div class="col-4 col-lg-2 align-self-md-center">
                  <h3 class="text-center mb-2">Síguenos</h3>
                  <div class="d-flex justify-content-around justify-content-lg-evenly">
                      <a href="https://www.facebook.com/vallenevadoskiresort" target="_blank">
                          <img class="img-fluid footer-icon" src="~__STATIC__/svg/facebook.svg" alt="Facebook"></a>
                      <a href="https://www.instagram.com/valle_nevado/" target="_blank">
                          <img class="img-fluid footer-icon" src="~__STATIC__/svg/instagram.svg" alt="instagram"></a>
                  </div>
              </div>
          </div>
        </div>
      </div>
  </footer>
</template>

<script>
    import cartMixin from '../mixins/cartMixin';
    import siteConfig from '../mixins/siteConfig';

    export default {
        mixins: [cartMixin, siteConfig],

        props: {
            hasStickyFooter: {
                type: Boolean,
                default() {
                    return false;
                }
            },
        },

        computed: {
            applySticketFooter () {
                if (window.location.pathname === this.getUrl('homeUrl') && this.count) {
                    return true;
                }

                return this.hasStickyFooter;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue